<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-data-mining`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 38a1 1 0 011 1v2a1 1 0 01-1 1H24a1 1 0 01-1-1v-2a1 1 0 011-1h19zM9 25a6.003 6.003 0 015.659 4H43a1 1 0 011 1v2a1 1 0 01-1 1H14.658A6.002 6.002 0 013 31a6 6 0 016-6zm0 4a2 2 0 100 4 2 2 0 000-4zm34-12a1 1 0 011 1v2a1 1 0 01-1 1H24a1 1 0 01-1-1v-2a1 1 0 011-1h19zM9 4a6.002 6.002 0 015.659 4H43a1 1 0 011 1v2a1 1 0 01-1 1H14.658A6.002 6.002 0 013 10a6 6 0 016-6zm0 4a2 2 0 100 4 2 2 0 000-4z"/></svg>
</template>
<script>

export default {
  name: 'IconDataMining',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
